<template>
  <div class="videoList">
    <headerBar :activeIndex="activeIndex"></headerBar>
    <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner>
    <div class="main-content">
      <div style="width: 100%; line-height: 30px; margin-top: 40px">
        <div class="big-title">
          <div class="big-name" style="">
            <span class="line-left"></span>
            <span class="txt" style="font-size: 30px; font-weight: bold"
              >视频资讯</span
            >
            <span class="line-right" ></span>
          </div>
        </div>
      </div>
      <div style="width: 100%;margin-top:80px;">
        <div class="new-Bar" v-for="(item,index) of videoList" :key="index" @click="goDetail(item.id)">
          <div class="videoBar">
            <img :src="item.cover_images" alt="" style="width: 100%;height:300px;" />
            <div class="videoBar-title">
              <div
                style="
                  position: absolute;
                  bottom: 0;
                  width: 100%;
                  padding: 10px 0;
                  font-size:16px;
                  background: rgba(0, 0, 0, 0.4);
                "
              >
                {{item.title}}
              </div>
            </div>
          </div>
        </div>
        <div style="clear:both"></div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import { getmenudetail,videolist } from "@/api/common";
export default {
  name: "videoList",
  components: { banner, footerBar, headerBar },
  data() {
    return {
      activeIndex: "news",
      info: { carousel: "", Mcarousel: "" },
      videoList:[],
      loading:false,
      showDialog: false,
      form:{
        page:1,
        pageSize:10
      },
      total:0
    };
  },
  mounted(){
    getmenudetail({ id: 8 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
    });
    this.loading = true
    videolist(this.form).then(res=>{
      this.total = res.data.totalcount
      this.videoList = res.data.list
      this.loading = false
    })
  },
  methods: {
    goDetail(id){
      var name = 'videoDetail'
      this.$router.push({ name,query:{id} });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.videoList .newImg {
  height: 260px;
}
.videoList .lishu {
  font-family: "Microsoft YaHei";
  font-size: 24px;
  position: relative;
}
.videoList .new-Bar {
  width: calc(50% - 50px);
  float: left;
  margin-right: 100px;
  margin-bottom: 30px;
}
.videoList .new-Bar:nth-child(2n) {
  margin-right: 0;
}
.videoList .new-content {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.videoList .videoBar {
  position: relative;
  width:80%;
  margin:0 auto;
}
.videoList .videoBar-title {
  position: absolute;
  width: 100%;
  bottom: 0px;
  left: 0;
  height: 90%;
  color: #fff;
  text-align: center;
  opacity: 1;
  padding: 0px 0;
  font-size: 12px;
  transition:all 0.5s
}
.videoList .videoBar-title:hover {
  opacity: 0.6;
}
.videoList .jiuyi {
  margin: 10px 0;
  padding: 10px;
  font-size: 16px;
}
@media screen and (max-width: 600px) {
  .videoList .newImg {
    width: 90%;
    margin: 5px auto;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news/videoList.vue